import Session from "supertokens-auth-react/recipe/session";
import {UserRoleClaim} from "supertokens-auth-react/recipe/userroles"
import { Navigate } from "react-router-dom";

const RoleAuth = ({ allowedRoles, children, doRedirect = false }) => {
    let claimValue = Session.useClaimValue(UserRoleClaim)

    if (claimValue.loading || !claimValue.doesSessionExist) {
        return null;
    }
    
    let roles = claimValue.value;
    if (!Array.isArray(roles) || !allowedRoles.some(role => roles.includes(role))) {
        if (doRedirect) {
            return <Navigate to="/access-denied" replace />;
        }
        return null;
    }

    return <>{children}</>;
};

export default RoleAuth;
